import React from 'react';
import Styles from './index.module.css';

export default function FeaturedDoodle() {
  return (
    <div className={Styles.mainContainer}>
      <div
        style={{
          flex: 2,
          display: 'flex',
          flexDirection: 'column',
          marginRight: 6,
        }}
      >
        <div className={Styles.doodleContainer} style={{ flex: 1, marginBottom: 6 }} />
        <div style={{ flex: 1, display: 'flex' }}>
          <div className={Styles.doodleContainer} style={{ flex: 1 }} />
          <div className={Styles.doodleContainer} style={{ flex: 1 }} />
        </div>
      </div>
      <div style={{ flex: 1 }}>
        <div className={Styles.doodleContainer} style={{ flex: 1 }} />
      </div>
    </div>
  );
}
